import { BaseFieldWidget, BaseTableFieldWidget, deepClone, ModelFieldType, RowContext, SPI, ViewType, Widget } from '@kunlun/dependencies';
import { createVNode, nextTick, VNode } from 'vue';
import ItemSkuAttrsHeader from './ItemSkuAttrsHeader.vue';
import ItemSkuAttrs from './ItemSkuAttrs.vue';
import { useAddItemSku } from '@/custom-widget/MindMap/hooks';

const { itemSkuHeaderList } = useAddItemSku();

type attrsItem = { attrName: string; attrValue: string; showDelIcon?: boolean }

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: ViewType.Table,
    ttype: ModelFieldType.OneToMany,
    widget: 'ItemSkuAttrsWidget'
  })
)
export class TableItemSkuAttrsWidget extends BaseTableFieldWidget {
  @Widget.Reactive()
  public get width() {
    return itemSkuHeaderList.value.length * 128;
  }
  private refresh: boolean = false;
  protected $$beforeCreated(): void {
    super.$$beforeCreated();
    this.refresh = true;
  }
  protected async $$updated() {
    await nextTick();
    if (this.lastContext && this.refresh) {
      itemSkuHeaderList.value = []
      this.renderDefaultSlot(this.lastContext)
      this.refresh = false
    }

    super.$$updated();
  }

  @Widget.Watch('width')
  protected async watchWidth(width) {
    await nextTick();


    this.getTableInstance()?.getOrigin().refreshColumn();
  }

  @Widget.Method()
  public renderHeaderSlot(context?: RowContext): VNode[] | string {
    return [
      createVNode(ItemSkuAttrsHeader, {
        dataSource: this.dataSource,
        itemName: this.itemName,
        viewType: this.getUrlParameters().viewType
      })
    ];
  }

  public invisibleDelIconByRetail(model: string, name: string, i: number) {
    const models = ['deli.retail.RetailItemSku'];
    const names = ["retailItemSku"]
    return models.includes(model) && names.includes(name) && i === 0;
  }

  private lastContext: RowContext | undefined;

  @Widget.Method()
  public renderDefaultSlot(context): VNode[] | string {
    this.lastContext = context;
    const currentValue = this.compute(context) as attrsItem[];
    if (!itemSkuHeaderList.value.length && currentValue?.length) {
      itemSkuHeaderList.value = currentValue.map((v, i) => {
        let initialized = true;
        /**即时零售 初始化时，隐藏删除按钮 抽离成公共组件时 可删除 */
        if (this.invisibleDelIconByRetail(this.model.model, this.model.name, i)) {
          initialized = false;
        }
        return { attrName: v.attrName, showDelIcon: v?.showDelIcon ?? initialized }
      });
    }
    return [createVNode(ItemSkuAttrs, { value: currentValue, viewType: this.getUrlParameters().viewType })];
  }
}
